import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FiEye,
  FiChevronRight,
  FiChevronLeft,
  FiHome,
  FiX,
  FiImage,
  FiMoreVertical,
  FiCheck,
  FiXCircle,
  FiSearch,
  FiDownload,
} from "react-icons/fi";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { getJoiningPaymentList, approveRejectJoiningPayment } from "../../store/slices/profile";

const PackageRequestHistory = () => {
  const dispatch = useDispatch();

  const [selectedImage, setSelectedImage] = useState(null);
  const [openAction, setOpenAction] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);

  const [search, setSearch] = useState("");
  const [activationType, setActivationType] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const {
    joiningPaymentList = [],
    joiningPaymentListLoading,
    joiningPaymentCount = 0,
    joiningPaymentActionLoading,
    error,
  } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(
      getJoiningPaymentList({
        status: "SUCCESS",
        userId: search.trim(),
        activationType,
        page,
        limit,
      })
    );
  }, [
    dispatch,
    page,
    limit,
    search,
    activationType,
  ]);
  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };


  const handlePaymentAction = async (transactionId, action) => {
    try {
      await dispatch(
        approveRejectJoiningPayment({
          transactionId,
          action,
        })
      ).unwrap();

      setOpenAction(null);

      dispatch(
        getJoiningPaymentList({
          status: "PENDING",
          page,
          limit,
        })
      ); dispatch(getJoiningPaymentList());

    } catch (error) {
      console.error("Payment action failed:", error);
    }
  };

  const closeImageViewer = () => {
    setSelectedImage(null);
  };

  const totalPages = Math.ceil(
    joiningPaymentCount / limit
  );

  const handlePrevious = () => {
    if (page > 1 && !joiningPaymentListLoading) {
      setPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (
      page < totalPages &&
      !joiningPaymentListLoading
    ) {
      setPage((prev) => prev + 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (
      pageNumber >= 1 &&
      pageNumber <= totalPages &&
      pageNumber !== page &&
      !joiningPaymentListLoading
    ) {
      setPage(pageNumber);
    }
  };

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (page <= 3) {
        pages.push(
          1,
          2,
          3,
          4,
          "...",
          totalPages
        );
      } else if (page >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          page - 1,
          page,
          page + 1,
          "...",
          totalPages
        );
      }
    }

    return pages;
  };

  const displayStart =
    joiningPaymentCount > 0
      ? (page - 1) * limit + 1
      : 0;

  const displayEnd = Math.min(
    page * limit,
    joiningPaymentCount
  );

  const handleDownloadPDF = async () => {
    try {
      setDownloadLoading(true);

      const response = await dispatch(
        getJoiningPaymentList({
          status: "SUCCESS",
          search: search.trim(),
          activationType,
          page: 1,
          limit: joiningPaymentCount || 100000,
        })
      ).unwrap();

      const exportList =
        response?.data?.joiningPaymentList ||
        response?.data?.payments ||
        response?.joiningPaymentList ||
        response?.payments ||
        [];

      if (!exportList.length) {
        alert("No records available to download.");
        return;
      }

      const doc = new jsPDF("landscape", "mm", "a4");

      doc.setFontSize(16);
      doc.text("Package Request History", 14, 15);

      doc.setFontSize(9);

      const tableData = exportList.map((item, index) => {
        const user = item.userId || {};

        const status = item.status || "PENDING";

        return [
          index + 1,
          user.name || "-",
          user.userId || "-",
          item.trn || "-",
          item.amount || 0,
          formatDate(item.createdAt),
          status,
        ];
      });

      autoTable(doc, {
        startY: 22,
        head: [
          [
            "#",
            "Name",
            "User ID",
            "Transaction ID",
            "Amount",
            "Date",
            "Status",
          ],
        ],
        body: tableData,
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 3,
        },
        headStyles: {
          fontSize: 8,
          fontStyle: "bold",
        },
      });

      doc.save("package-request-history.pdf");
    } catch (error) {
      console.error("PDF download failed:", error);
      alert("Failed to download PDF.");
    } finally {
      setDownloadLoading(false);
    }
  };
  return (
    <div className="gi-referral-page">

      <div className="gi-breadcrumb">

        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Package Request
        </span>
        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Package Request History
        </span>

      </div>

      <section className="gi-referral-table-card">
        <div className="gi-users-filter">

          {/* PER PAGE */}
          <div className="gi-users-page-size me-2">
            <label htmlFor="pageSize">
              Show
            </label>

            <select
              id="pageSize"
              value={limit}
              onChange={(e) => {
                const newLimit = Number(e.target.value);

                setLimit(newLimit);
                setPage(1);
              }}
              disabled={joiningPaymentListLoading}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>

            <span>per page</span>
          </div>

          {/* SEARCH */}
          <div className="gi-users-search me-2">
            <FiSearch />

            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              placeholder="Search by name, user ID or transaction ID..."
            />
          </div>
          {/* ACTIVATION FILTER */}
          <div className="gi-users-page-size me-2">
            <select
              value={activationType}
              onChange={(e) => {
                setActivationType(e.target.value);
                setPage(1);
              }}
              disabled={joiningPaymentListLoading}
            >
              <option value="">
                All Activation Types
              </option>

              <option value="WALLET">
                Wallet Activated
              </option>

              <option value="PAYMENT">
                Payment Activated
              </option>
            </select>
          </div>
          {/* DOWNLOAD */}
          <button
            type="button"
            className="gi-user-export-btn"
            onClick={handleDownloadPDF}
            disabled={
              downloadLoading ||
              joiningPaymentListLoading ||
              joiningPaymentCount === 0
            }
          >
            <FiDownload />

            <span>
              {downloadLoading
                ? "Downloading..."
                : "Download PDF"}
            </span>
          </button>

        </div>
        <div className="gi-referral-table-wrapper">

          <table className="gi-referral-table">

            <thead>
              <tr>
                <th>#</th>

                <th>
                  Name
                </th>

                <th className="text-center">
                  User ID
                </th>

                <th className="text-center">
                  Transaction ID
                </th>

                <th className="text-center">
                  Amount
                </th>

                <th className="text-center">
                  Payment Image
                </th>

                <th className="text-center">
                  Date
                </th>

                <th className="text-center">
                  Status
                </th>

                <th className="text-center">
                  Action
                </th>
              </tr>
            </thead>


            <tbody>

              {joiningPaymentListLoading && (

                <tr>

                  <td
                    colSpan="9"
                    className="gi-table-message"
                  >
                    Loading payments...
                  </td>

                </tr>

              )}

              {!joiningPaymentListLoading && error && (

                <tr>

                  <td
                    colSpan="9"
                    className="gi-table-message"
                  >
                    {error}
                  </td>

                </tr>

              )}


              {!joiningPaymentListLoading &&
                !error &&
                joiningPaymentList.length === 0 && (

                  <tr>

                    <td
                      colSpan="9"
                      className="gi-table-message"
                    >
                      No pending package request found!
                    </td>

                  </tr>

                )}

              {!joiningPaymentListLoading &&
                !error &&
                joiningPaymentList.map((item, index) => {

                  const user = item.userId || {};

                  const status =
                    item.status ||
                    "PENDING";

                  return (

                    <tr
                      key={item._id || index}
                    >
                      <td>
                        {String((page - 1) * limit + index + 1).padStart(2, "0")}
                      </td>


                      <td>
                        {user.name || "-"}

                      </td>


                      <td className="text-center">

                        <span >

                          {user.userId || "-"}

                        </span>

                      </td>


                      <td className="text-center">

                        <span >

                          {item.trn || "-"}

                        </span>

                      </td>


                      <td className="text-center">

                        <strong className="gi-payment-amount">

                          ${item.amount || 0}

                        </strong>

                      </td>

                      <td className="text-center">

                        {item.trnImage ? (

                          <button
                            type="button"
                            className="gi-view-image-btn"
                            onClick={() =>
                              setSelectedImage({
                                url: item.trnImage,
                                userName: user.name,
                                transactionId: item.transactionId,
                              })
                            }
                          >
                            <FiEye />
                          </button>

                        ) : (

                          <span className="gi-no-image">

                            No Image

                          </span>

                        )}

                      </td>

                      <td className="text-center">

                        <span className="gi-date-text">

                          {formatDate(item.createdAt)}

                        </span>

                      </td>

                      <td className="text-center">

                        <span
                          className={`gi-status-badge ${status.toLowerCase()}`}
                        >


                          {status}
                        </span>

                      </td>

                      <td className="text-center">

                        {status === "PENDING" ? (

                          <div className="gi-payment-action-wrap">

                            <button
                              type="button"
                              className="gi-payment-action-btn"
                              onClick={() =>
                                setOpenAction(
                                  openAction === item._id
                                    ? null
                                    : item._id
                                )
                              }
                            >
                              <FiMoreVertical />
                            </button>


                            {openAction === item._id && (

                              <div className="gi-payment-action-menu">

                                <button
                                  type="button"
                                  className="gi-action-approve"
                                  disabled={joiningPaymentActionLoading}
                                  onClick={() =>
                                    handlePaymentAction(
                                      item._id,
                                      "APPROVE"
                                    )
                                  }
                                >
                                  <FiCheck />

                                  Approve
                                </button>


                                <button
                                  type="button"
                                  className="gi-action-reject"
                                  disabled={joiningPaymentActionLoading}
                                  onClick={() =>
                                    handlePaymentAction(
                                      item._id,
                                      "REJECT"
                                    )
                                  }
                                >
                                  <FiXCircle />

                                  Reject
                                </button>

                              </div>

                            )}

                          </div>

                        ) : (

                          <span className="gi-action-completed">
                            Approved
                          </span>

                        )}

                      </td>

                    </tr>

                  );

                })}

            </tbody>

          </table>
          {/* ================= PAGINATION ================= */}

          {joiningPaymentCount > 0 && (
            <div className="gi-users-pagination">

              {/* PAGINATION INFO */}

              <div className="gi-pagination-info">
                Showing{" "}

                <strong>
                  {displayStart}
                </strong>

                {" "}to{" "}

                <strong>
                  {displayEnd}
                </strong>

                {" "}of{" "}

                <strong>
                  {joiningPaymentCount}
                </strong>

                {" "}requests
              </div>


              {/* PAGINATION BUTTONS */}

              <div className="gi-pagination-buttons">

                {/* PREVIOUS */}

                <button
                  type="button"
                  className="gi-pagination-btn"
                  onClick={handlePrevious}
                  disabled={
                    page === 1 ||
                    joiningPaymentListLoading
                  }
                >
                  <FiChevronLeft />


                </button>


                {/* PAGE NUMBERS */}

                {getPageNumbers().map(
                  (pageNumber, index) => {

                    if (pageNumber === "...") {
                      return (
                        <span
                          key={`dots-${index}`}
                          className="gi-pagination-dots"
                        >
                          ...
                        </span>
                      );
                    }

                    return (
                      <button
                        type="button"
                        key={pageNumber}
                        className={`gi-pagination-number ${page === pageNumber
                          ? "active"
                          : ""
                          }`}
                        onClick={() =>
                          handlePageChange(pageNumber)
                        }
                        disabled={joiningPaymentListLoading}
                      >
                        {pageNumber}
                      </button>
                    );
                  }
                )}


                {/* NEXT */}

                <button
                  type="button"
                  className="gi-pagination-btn"
                  onClick={handleNext}
                  disabled={
                    page >= totalPages ||
                    joiningPaymentListLoading
                  }
                >


                  <FiChevronRight />
                </button>

              </div>

            </div>
          )}

        </div>

      </section>

      {selectedImage && (

        <div
          className="gi-image-viewer-overlay"
          onClick={closeImageViewer}
        >

          <div
            className="gi-image-viewer-modal"
            onClick={(e) => e.stopPropagation()}
          >

            {/* CLOSE */}

            <button
              type="button"
              className="gi-image-viewer-close"
              onClick={closeImageViewer}
            >

              <FiX />

            </button>


            {/* HEADER */}

            <div className="gi-image-viewer-header">

              <div className="gi-image-viewer-title">

                <div className="gi-image-viewer-icon">

                  <FiImage />

                </div>


                <div>

                  <h3>
                    Payment Proof
                  </h3>

                  <p>
                    {selectedImage.userName || "User"}
                  </p>

                </div>

              </div>

            </div>


            {/* IMAGE */}

            <div className="gi-image-viewer-body">

              <img
                src={selectedImage.url}
                alt="Payment Proof"
              />

            </div>



          </div>

        </div>

      )}

    </div>
  );
};

export default PackageRequestHistory;